import { FaMinus, FaPlus } from "react-icons/fa";

const AddonCounter = ({ quantity, onChange }) => {
  return (
    <div className="d-flex align-items-center">
      <div
        className="top_cards__operators-active d-flex justify-content-center align-items-center"
        style={{ width: "24px", height: "24px" }}
        onClick={() => onChange(Math.max(0, quantity - 1))}
      >
        <FaMinus />
      </div>
      <span className="mx-2 text-black">
        {quantity}
      </span>
      <div
        className="top_cards__operators-active d-flex justify-content-center align-items-center"
        style={{ width: "24px", height: "24px" }}
        onClick={() => onChange(quantity + 1)}
      >
        <FaPlus />
      </div>
    </div>
  );
};

export default AddonCounter;
